import Validate from './validate.js'
export default {
    install(Vue, options) {
        let instance = new Validate(Vue)
        Vue.prototype.$validate = (scope, opt = []) => {
            return instance.valid(scope, opt)
        }
    }
}


// WEBPACK FOOTER //
// ./src/plugins/validate/index.js